<template>
  <div v-if="!isLogined" style="padding-top:300px;">
      <p>您还没有登录哦，请先登录</p>
      <van-button round @click="ShowLogin" type="info">点击登录</van-button>
  </div>
  <div v-else>
     <van-nav-bar title="收货地址编辑" left-text="" left-arrow @click-left="onClickLeft()" />
     <van-address-edit
      :area-list="areaList"
      :address-info="AddressInfo"
      show-postal
      show-delete
      show-set-default
      show-search-result
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      @save="SaveAddress"
      @delete="onDelete"
    />
     
  </div>
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup, NavBar, AddressEdit } from "vant";
import { Button, Field } from "vant";
import { Divider } from "vant";
import { Popup } from "vant";
import { CountDown } from 'vant';
import { Dialog } from 'vant';
import area from '../utils/area'
import { debug } from 'util';
export default {
  name: "ReciveAddrsEdit",
  data() {
    return {
      addrId: 0,
      areaList:area,
      ReciveAddr: {},     
      AddressInfo:{}
    };
  },
  props: {},
  computed:{
    isLogined(){return this.$store.state.isLogin}
  },
  methods: {
    ShowLogin(){
      this.$store.commit("showLogin");
    },
    /*返回 */
    onClickLeft() {
      this.$router.back(-1);
    },
    GetData(){//初始化收货地址
      var that = this;
      that.$http.get("Prizes/GetAddrById?id="+that.addrId).then((res) => {
        var addr = res.data.Data;
        var province_ = addr.RegionFullDesc.slice(0,3);
        var city_ = addr.RegionFullDesc.slice(3,6);
        var county_ = addr.RegionFullDesc.slice(6,12);
        that.AddressInfo={
          id:addr.ID,
          name:addr.ContractName,
          tel:addr.ContractTel,
          province:province_,
          city:city_,
          county:county_,
          addressDetail:addr.DetailAddr,
          areaCode:addr.RegionLevel3+"",
          isDefault:addr.IsDefault==1?true:false
        };
      });
    },
    SaveAddress(data){//保存收货地址  
      this.AddressInfo=data;
      this.ReciveAddr={
        id: this.addrId,
        userName:data.name,
        telNumber:data.tel,
        provinceName:data.province,
        cityName:data.city,
        countyName:data.county,
        detailInfo:data.addressDetail,
        areaCode:data.areaCode,
        isDefault:data.isDefault?1:0
      };
      var that=this;
      that.$http.post("Prizes/CreateConvertAddr",that.ReciveAddr).then(res=>{
        if(res.data=="success"){
          that.$toast("操作成功");
          that.$router.back(-1);
        }else{
          that.$toast(res.data);
        }
      });
    },
    onDelete(data){//收货地址删除（未使用地址可删除）
      var that=this;
      that.$http.get("Prizes/DeleteAddr", {
        params: { 
            id: data.id 
        }
      }).then(res => {
        if(res.data=="success"){
          that.$toast("操作成功");
          that.$router.back(-1);
        }else{
          that.$toast(res.data);
        }
      });
    },
  },
  created() {
    this.addrId = this.$route.params.addrid;
    if(this.addrId!=0&&this.addrId!=undefined){
      this.GetData();
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [CountDown.name]:CountDown,
    [NavBar.name]: NavBar,
    [AddressEdit.name]: AddressEdit,
  },
};
</script>

<style scoped>
    .van-panel {
    margin-top: 20px;
  }
</style>
